import axios from "axios";

class AdminSimulateService {

     simulateRole(roleName: string): Promise<any> {
         return axios.post(`admin/company/role/impersonate/${roleName}`);
     }

}

export default AdminSimulateService;
